import React, { useState, useEffect } from 'react';
import { Button, Form, Radio, App } from 'antd';
import styles from './StorePublishProductStep3.module.scss';
import { IFormDataAll } from '../../types';
import { useTranslation } from 'react-i18next';
export interface StorePublishProductStep3Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  formData?: IFormDataAll;
}






// 产品发布第三步：物流服务
const StorePublishProductStep3: React.FC<StorePublishProductStep3Props> = ({
  onNext,
  onPrev,
  formData
}) => {
  const { t, i18n } = useTranslation();
  const { message } = App.useApp();
  const [form] = Form.useForm();

  // 物流服务选项
  const [launchDate, setLaunchDate] = useState<string>('24hours');
  const [pickupMethod, setPickupMethod] = useState<number>(1);

  // 初始化数据
  useEffect(() => {
    if (formData) {
      setLaunchDate(formData.delivery_estimated_time || '24hours');
      setPickupMethod(formData.delivery_method || 1);
    }
  }, [formData]);



  // 处理提交
  const handleSubmit = () => {
    const submitData = {
      delivery_estimated_time: launchDate,
      delivery_method: pickupMethod,
    };

    console.log('Logistics form values:', submitData);
    onNext && onNext(submitData);
  };

  // 返回上一步
  const handlePrev = () => {

    onPrev && onPrev();
  };

  return (
    <div className={styles['store-publish-product-step3']}>
      <div className={styles['main-title']}>{t('StorePublishProductStep3.LogisticsServices')}</div>

      <Form form={form} layout="vertical">

        {/* 取货方式 */}
        <div className={styles['form-item']}>
          <div className={styles['form-label']}>{t('StorePublishProductStep3.PickupMethod')}</div>
          <Radio.Group
            value={pickupMethod}
            onChange={(e) => setPickupMethod(e.target.value)}
            className={styles['radio-group']}
            disabled={true}
          >
            <Radio value={1} className={styles['radio-button']}>{t('StorePublishProductStep3.Picstore')}</Radio>
            {/* <Radio value={2} className={styles['radio-button']}>Provide home delivery service</Radio>
            <Radio value={3} className={styles['radio-button']}>Express delivery</Radio> */}

          </Radio.Group>
        </div>


        {/* 发货日期 */}
        {/* <div className={styles['form-item']}>
          <div className={styles['form-label']}>* Launch Date</div>
          <Radio.Group
            value={launchDate}
            onChange={(e) => setLaunchDate(e.target.value)}
            className={styles['radio-group']}
          >
            <Radio value="24hours" className={styles['radio-button']}>Ship Within 24 Hours</Radio>
            <Radio value="48hours" className={styles['radio-button']}>Ship Within 48 Hours</Radio>
          </Radio.Group>
        </div> */}




        {/* 按钮区域 */}
        <div className={styles['button-container']}>
          <Button
            className={styles['prev-button']}
            onClick={handlePrev}
          >
            {t('StorePublishProductStep3.Prev')}
          </Button>

          <Button
            type="primary"
            className={styles['next-button']}
            onClick={handleSubmit}
          >
            {t('StorePublishProductStep3.Next')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default StorePublishProductStep3;  